import { useRoute } from '../../context/RouteContext';
import './RouteOptions.css';

// Which avoid keys apply to each Valhalla costing profile
const PROFILE_SUPPORT = {
  driving:  ['motorway', 'toll', 'ferry'],
  cycling:  ['ferry'],
  foot:     ['ferry'],
};

const OPTIONS = [
  {
    key: 'motorway',
    label: 'Highways & Motorways',
    description: 'Avoid freeways and motorways',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
        <path d="M3 17l3-10 3 4 3-4 3 4 3-10"/>
        <line x1="3" y1="17" x2="21" y2="17"/>
      </svg>
    ),
  },
  {
    key: 'toll',
    label: 'Toll Roads',
    description: 'Avoid roads with tolls',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
        <circle cx="12" cy="12" r="9"/>
        <path d="M9 9h6M9 12h6M9 15h4"/>
      </svg>
    ),
  },
  {
    key: 'ferry',
    label: 'Ferries',
    description: 'Avoid ferry crossings',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
        <path d="M2 20h20M5 16l2-8h10l2 8"/>
        <path d="M12 8V4M9 4h6"/>
      </svg>
    ),
  },
];

export function RouteOptions() {
  const { state, dispatch } = useRoute();
  const { avoidOptions, profile } = state;

  const toggle = (key) => dispatch({ type: 'TOGGLE_AVOID', payload: key });

  const supported = PROFILE_SUPPORT[profile] ?? PROFILE_SUPPORT.driving;
  const activeCount = Object.entries(avoidOptions)
    .filter(([k, v]) => v && supported.includes(k)).length;

  return (
    <div className="route-options">
      <div className="route-options__header">
        <span className="route-options__title">Avoid</span>
        {activeCount > 0 && (
          <span className="route-options__active-badge">{activeCount} active</span>
        )}
      </div>
      <div className="route-options__list">
        {OPTIONS.map(({ key, label, description, icon }) => {
          const active = avoidOptions[key];
          const disabled = !supported.includes(key);
          return (
            <label
              key={key}
              className={[
                'route-option',
                active && !disabled ? 'route-option--active' : '',
                disabled ? 'route-option--disabled' : '',
              ].join(' ').trim()}
            >
              <span className="route-option__icon">{icon}</span>
              <span className="route-option__text">
                <span className="route-option__label">{label}</span>
                <span className="route-option__desc">
                  {disabled ? 'Not applicable for this profile' : description}
                </span>
              </span>
              <span className={`route-option__toggle${active && !disabled ? ' route-option__toggle--on' : ''}`}>
                <span className="route-option__thumb" />
              </span>
              <input
                type="checkbox"
                className="route-option__checkbox"
                checked={active}
                disabled={disabled}
                onChange={() => !disabled && toggle(key)}
                aria-label={`Avoid ${label}`}
              />
            </label>
          );
        })}
      </div>
    </div>
  );
}
